module.exports = __webpack_public_path__ + "static/assets/1d4eb1c31252d34c6fb2378d2384dd7e.png";